import { render } from "./ApprovalMonitor.vue?vue&type=template&id=0c9f2bd3"
import script from "./ApprovalMonitor.vue?vue&type=script&lang=js"
export * from "./ApprovalMonitor.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/apps/crm/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__